import { AssetsLoader } from '@dealstack/frontend/shared/components/AssetsLoader/AssetsLoader';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { SectionHeader } from '@dealstack/frontend/shared/components/SectionHeader/SectionHeader';
import {
	TransMipManage,
	useTranslationMipManage,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { memo } from 'react';
import styled from 'styled-components';

const NewJoinersAndAllocationsIntroductionStep = () => {
	const tMipManage = useTranslationMipManage();

	return (
		<TabContent>
			<TabDescription>
				<SectionHeader
					size="h4b"
					title={tMipManage('investors.upsert_investor_shares_modal.introduction_title')}
					overtitle={tMipManage(
						'investors.upsert_investor_shares_modal.introduction_overtitle'
					)}
				/>
				<Text colorFaded variant="p-lg">
					<TransMipManage i18nKey="investors.upsert_investor_shares_modal.introduction_text" />
				</Text>
			</TabDescription>
			<ImageWrapper>
				<AssetsLoader src="/context/admin/mip-manage/new_joiner.png" />
			</ImageWrapper>
		</TabContent>
	);
};

const TabContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 2.5em;
	margin: 2em 0;
`;

const TabDescription = styled.div`
	flex-grow: 1;

	${SectionHeader} {
		margin-bottom: 0.8em;
	}
`;

const ImageWrapper = styled.div`
	min-width: 30rem;
	max-width: 30rem;
	height: 21.5rem;

	img {
		width: 100%;
		height: 100%;
	}
`;
const _NewJoinersAndAllocationsIntroductionStepExport = memo(
	NewJoinersAndAllocationsIntroductionStep
);

export { _NewJoinersAndAllocationsIntroductionStepExport as NewJoinersAndAllocationsIntroductionStep };
